import SortImagesButtons from '../SortImagesActivity/SortImagesButtons';

export default function RealTimeButtons({ activity }) {
  const ActivityButtons = {
    sortImages: SortImagesButtons,
  }[activity.data.subType];

  return <ActivityButtons activity={activity} />;
}
